import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@feathr/components';

import * as styles from './ConfigureFiltersButton.css';
interface IProps {
  onClick: () => void;
}

function ConfigureFiltersButton({ onClick }: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();
  return (
    <Button buttonShape={'pill'} className={styles.root} onClick={onClick} type={'secondary'}>
      {t('Configure filters')}
    </Button>
  );
}

export default ConfigureFiltersButton;
